var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNobodyBeatsUs32 = function SvgNobodyBeatsUs32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.235 13.786a.286.286 0 0 1 .281.313 2.606 2.606 0 0 1-.602 1.583 2.295 2.295 0 0 1-1.84.713h-3.789a.282.282 0 0 1-.285-.282v-.937a.275.275 0 0 1 .2-.268 1 1 0 0 0 .256-.11c.151-.086.285-.198.396-.332a1.55 1.55 0 0 0 .274-.484 1.67 1.67 0 0 0 .104-.589 2.218 2.218 0 0 0-.104-.61h-.805a.285.285 0 0 1-.285-.284v-.656a.285.285 0 0 1 .285-.285h.356a2.904 2.904 0 0 1-.124-.845 2.77 2.77 0 0 1 .21-1.07c.134-.323.333-.616.584-.859.257-.249.562-.444.895-.574a3.293 3.293 0 0 1 2.913.296c.389.27.698.639.894 1.07a.29.29 0 0 1-.167.395l-.852.278a.274.274 0 0 1-.328-.12 1.467 1.467 0 0 0-.456-.5 1.565 1.565 0 0 0-.88-.246 1.355 1.355 0 0 0-1.013.381 1.388 1.388 0 0 0-.357 1.002c.01.27.063.536.157.788h2.578a.281.281 0 0 1 .281.285v.656a.282.282 0 0 1-.282.285h-2.16c.034.193.05.389.046.585.003.316-.049.631-.153.93-.087.264-.258.49-.488.646h2.103c.684 0 1.07-.304 1.137-.91a.277.277 0 0 1 .278-.249l.742.004Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.647 15H6.872a3.44 3.44 0 0 0-1.162.19c-.9.309-1.715.842-2.371 1.553a1.412 1.412 0 0 0-.339.94v6.007c0 .172.032.343.095.502a1.291 1.291 0 0 0 .683.709c.153.066.317.1.482.099h17.48c.334 0 .655-.138.89-.384.237-.245.37-.578.37-.926v-2.986",
    stroke: "currentColor",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.035 10H9.368a1.83 1.83 0 0 0-1.28.517C6.308 12.27 6.035 15 6.035 15",
    stroke: "currentColor",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25a5.173 5.173 0 0 0-1.113-2.69.939.939 0 0 0-.682-.31h-4.413a.946.946 0 0 0-.683.31A5.174 5.174 0 0 0 9 25m-1 .053v1.738c0 .16-.026.317-.076.464a1.25 1.25 0 0 1-.217.393 1.005 1.005 0 0 1-.325.261.847.847 0 0 1-.383.091H4.997a.845.845 0 0 1-.382-.09 1.004 1.004 0 0 1-.324-.263 1.247 1.247 0 0 1-.216-.392A1.43 1.43 0 0 1 4 26.79V25m19 0v1.908c0 .144-.026.286-.076.419s-.125.253-.218.355a.995.995 0 0 1-.324.236.922.922 0 0 1-.383.082h-2.002a.918.918 0 0 1-.382-.082.993.993 0 0 1-.324-.237 1.1 1.1 0 0 1-.216-.355 1.18 1.18 0 0 1-.075-.418V25M5.454 14H3.546c-.302 0-.546.224-.546.5s.244.5.546.5h1.908c.302 0 .546-.224.546-.5s-.244-.5-.546-.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNobodyBeatsUs32;